import { isBusiness } from "owa-session-store";
import { getStore } from "../store/store";
import type { MailboxInfo } from "owa-client-types";
import { isUnifiedInboxMailboxInfo } from "owa-client-types/lib/UnifiedInboxMailboxInfo";

export default function getIsTeamsChatTabEnabled(mailboxInfo: MailboxInfo): boolean {
    return (isBusiness(mailboxInfo) &&
        !isUnifiedInboxMailboxInfo(mailboxInfo) &&
        getStore().isTeamsChatEnabled);
}
